import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { Form } from 'react-bootstrap';
import Spinner from 'react-bootstrap/Spinner';
import Button from 'react-bootstrap/Button';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import { fr } from "date-fns/locale";
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { AfficheService, AjouteParametragePromo, AfficheParametragePromo, AjouteSansOffre, AfficheSansOffre, AffichePromoMinOffre } from "../../Api/RestaurantApi/OffreApi";
import { useSelector } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import './css/offrePromoResto.css';

const OffrePromo = () => {
    const [du, setDu] = useState(new Date());
    const [au, setAu] = useState(new Date());
    const [errorDu, setErrorDu] = useState('');
    const [errorAu, setErrorAu] = useState('');
    const [statusPromo, setStatusPromo] = useState(false);
    const [promoMin, setPromoMin] = useState('');

    const [error50, setError50] = useState('');
    const [error40, setError40] = useState('');
    const [error30, setError30] = useState('');
    const [error20, setError20] = useState('');
    const [error10, setError10] = useState('');
    const [errorSpecial, setErrorSpecial] = useState('');

    let location = useLocation();

    const [dataPromo, setDataPromo] = useState([]);
    const [info, setInfo] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadData, setLoadData] = useState(false);
    const [loadDataSansOffre, setLoadDataSansOffre] = useState(false);
    const [loadingSansOffre, setLoadingSansOffre] = useState(false);



    const restaurant = useSelector((state) => state.restaurant);

    const [sansOffreMenuBase, setSansOffreMenuBase] = useState([
        {
            id: 1,
            name: "diner",
            capaciter: "",
            lundi: "",
            mardi: "",
            mercredi: "",
            jeudi: "",
            vendredi: "",
            samedi: "",
            dimanche: "",
        },
        {
            id: 2,
            name: "petitDejeuner",
            capaciter: "",
            lundi: "",
            mardi: "",
            mercredi: "",
            jeudi: "",
            vendredi: "",
            samedi: "",
            dimanche: "",
        },
        {
            id: 3,
            name: "dejeuner",
            capaciter: "",
            lundi: "",
            mardi: "",
            mercredi: "",
            jeudi: "",
            vendredi: "",
            samedi: "",
            dimanche: "",
        }
    ]);


    const [sansOffreMenu, setSansOffreMenu] = useState([
        {
            id: 1,
            name: "diner",
            capaciter: "",
            lundi: "",
            mardi: "",
            mercredi: "",
            jeudi: "",
            vendredi: "",
            samedi: "",
            dimanche: "",
        },
        {
            id: 2,
            name: "petitDejeuner",
            capaciter: "",
            lundi: "",
            mardi: "",
            mercredi: "",
            jeudi: "",
            vendredi: "",
            samedi: "",
            dimanche: "",
        },
        {
            id: 3,
            name: "dejeuner",
            capaciter: "",
            lundi: "",
            mardi: "",
            mercredi: "",
            jeudi: "",
            vendredi: "",
            samedi: "",
            dimanche: "",
        }
    ]);

    const [reservationDirect, setReservationDirect] = useState([
        {
            id: 1,
            name: "diner",
            capaciter: "",
            lundi: "",
            mardi: "",
            mercredi: "",
            jeudi: "",
            vendredi: "",
            samedi: "",
            dimanche: "",
        },
        {
            id: 2,
            name: "petitDejeuner",
            capaciter: "",
            lundi: "",
            mardi: "",
            mercredi: "",
            jeudi: "",
            vendredi: "",
            samedi: "",
            dimanche: "",
        },
        {
            id: 3,
            name: "dejeuner",
            capaciter: "",
            lundi: "",
            mardi: "",
            mercredi: "",
            jeudi: "",
            vendredi: "",
            samedi: "",
            dimanche: "",
        }
    ]);


    useEffect(() => {
        // Calcul de la différence en jours
        const diffInMillis = au - du;  // Différence en millisecondes
        const diffInDays = Math.floor(diffInMillis / (1000 * 60 * 60 * 24)); // Conversion de la différence en jours

        if (diffInDays < promoMin) {
            setErrorAu(`La promotion doit être d'au moins ${promoMin} jour(s).`);
        } else {
            setErrorAu('');
        }
    }, [du, au, promoMin]);


    const AffichePromotionMin = () => {
        AffichePromoMinOffre().then(function (response) {
            setPromoMin(response.data?.donner[0].min);
        }).catch(function (error) {
            console.log(error);
        });
    }

    const handleEndPromo = (date) => {
        const diffInMillis = date - du;
        const diffInDays = Math.floor(diffInMillis / (1000 * 60 * 60 * 24));

        if (diffInDays < promoMin) {
            setErrorAu(`La promotion doit être d'au moins ${promoMin} jour(s).`);
            setAu(new Date());
        } else {
            setAu(date);
            setErrorAu('');
        }
    }

    const AfficheSansOffreData = () => {
        setLoadDataSansOffre(true);
        AfficheSansOffre(restaurant.id).then(function (response) {
            response.data.donner.sansOffre.forEach((el, i) => {
                setSansOffreMenuBase((prev) => {
                    return prev.map((item) => {
                        if (el.service === item.name) {
                            return { ...item, lundi: el.lundi, mardi: el.mardi, mercredi: el.mercredi, jeudi: el.jeudi, vendredi: el.vendredi, samedi: el.samedi, dimanche: el.dimanche }
                        } else {
                            return { ...item }
                        }
                    })
                });
            });

            response.data.donner.offreDirect.forEach((el, i) => {

                setReservationDirect((prev) => {
                    return prev.map((item) => {
                        if (el.service === item.name) {
                            return { ...item, lundi: el.lundi, mardi: el.mardi, mercredi: el.mercredi, jeudi: el.jeudi, vendredi: el.vendredi, samedi: el.samedi, dimanche: el.dimanche }
                        } else {
                            return { ...item }
                        }
                    })
                });


            });


        }).catch(function (error) {
            console.log(error);
        }).finally(function () {
            setLoadDataSansOffre(false);
        });
    }

    useEffect(() => {
        AffichePromotionMin();
        AfficheParametragePromotion();
        AfficheSansOffreData();
    }, []);

    console.log('promoMin', promoMin);

    useEffect(() => {
        AfficheService(restaurant.id).then(function (response) {
            setInfo(response.data.donner);

            const jours = ["lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi", "dimanche"];

            const updatedSansOffreMenu = sansOffreMenu.map((item) => {
                const match = response.data.donner.find(d => d.service === item.name);
                const capacite = match ? Number(match.capaciter) : 0;

                const reservation = reservationDirect.find(r => r.name === item.name);
                const promos = dataPromo.filter(p => p.service === item.name);

                // Obtenir les jours d'ouverture autorisés pour ce service
                const joursOuverts = match?.ouvertures.map(o => o.libelle.toLowerCase()) || [];

                const joursCapacite = jours.reduce((acc, jour) => {
                    if (!joursOuverts.includes(jour)) {
                        return acc; // Ne pas traiter ce jour s'il n'est pas dans les ouvertures
                    }

                    const consoReservation = reservation && reservation[jour] ? Number(reservation[jour]) : 0;

                    const consoPromo = promos.reduce((sum, p) => {
                        const value = p[jour];
                        return sum + (value ? Number(value) : 0);
                    }, 0);

                    const totalConsommation = consoReservation + consoPromo;
                    const dispo = Math.max(capacite - totalConsommation, 0);

                    acc[jour] = String(dispo);
                    return acc;
                }, {});

                return {
                    ...item,
                    capaciter: String(capacite),
                    ...joursCapacite
                };
            });

            setSansOffreMenu(updatedSansOffreMenu);
        }).catch(function (error) {
            console.log(error);
        });
    }, [restaurant.id, reservationDirect, dataPromo]);



    useEffect(() => {
        const jours = ["lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi", "dimanche"];

        // Vérifie si au moins un jour est rempli dans sansOffreMenu
        const isSansOffreMenuRempli = sansOffreMenu.some(item =>
            jours.some(jour => item[jour] && item[jour].trim() !== "")
        );

        // Vérifie si tous les jours sont vides dans tous les objets de sansOffreMenuBase
        const isSansOffreMenuBaseVide = sansOffreMenuBase.every(item =>
            jours.every(jour => !item[jour] || item[jour].trim() === "")
        );

        if (isSansOffreMenuRempli && isSansOffreMenuBaseVide) {
            const data = {
                idRestaurant: restaurant.id,
                sansOffre: sansOffreMenu
            };
            AjouteSansOffre(data)
                .then(function (response) {
                })
                .catch(function (error) {
                    console.log(error.response);
                    toast.warning(error.response.data?.message);
                });
        }
    }, [restaurant.id, sansOffreMenu, sansOffreMenuBase]);



    const dateFormat = (date) => {
        if (date < 10) {
            return '0' + date;
        } else {
            return date;
        }
    }


    const format = (datet) => {
        let date = new Date(datet);
        return date;
    }


    const safeParseFloat = (str) => {

        const value = Number.parseFloat(str);

        return Number.isNaN(value) ? 0 : value;
    }

    const blockInvalidChar = (e, id, service) => {
        if (["e", "E", "+", "-", ".", ","].includes(e.key)) {
            e.preventDefault();
        } else {
            if (service === "" || service === null) {
                setDataPromo((prev) => {
                    return prev.map((item) => {
                        if (item.id === id) {
                            return { ...item, error: "Select service" };
                        } else {
                            return { ...item };
                        }
                    });
                });
                e.preventDefault();
            }
        }
    }


    const options = [
        { value: 'dejeuner', label: 'Déjeuner' },
        { value: 'diner', label: 'Diner' },
        { value: 'petitDejeuner', label: 'Petit déjeuner' },
    ];


    const handleAddPromo50 = () => {
        if (info.length === 0) {
            toast.success("Remplisez d'abord les informations du resto dans l'ongle info générales");
        } else {
            const donnerPromo50 = dataPromo.filter((el) => el.name === "promo50");
            console.log(donnerPromo50.length);
            if (donnerPromo50.length < 3) {
                setError50('');
                setDataPromo((prev) => [...prev, {
                    id: dataPromo.length + 1, name: "promo50", service: "", capaciter: "",
                    lundi: "", mardi: "", mercredi: "", jeudi: "", vendredi: "", samedi: "", dimanche: "", error: ""
                }]);
            } else {
                setError50('Promotion -50% max 3');
                const timer = setTimeout(() => setError50(''), 3000);
                return () => clearTimeout(timer);
            }
        }

    }


    const AfficheParametragePromotion = () => {
        setLoadData(true);
        AfficheParametragePromo(restaurant.id).then(function (response) {

            console.log(response.data.donner);
            response.data.donner.forEach((el, i) => {
                setStatusPromo(el.status === "1" ? true : false);
                setAu(format(el.au));
                setDu(format(el.du));

                el.promotions.map((promotions) => {
                    return setDataPromo((prev) => [...prev, {
                        id: uuidv4(), name: promotions.promotion, service: promotions.service, capaciter: promotions.capaciter,
                        lundi: promotions.lundi, mardi: promotions.mardi, mercredi: promotions.mercredi, jeudi: promotions.jeudi, vendredi: promotions.vendredi, samedi: promotions.samedi, dimanche: promotions.dimanche, error: ""
                    }]);
                });

            });

        }).catch(function (error) {
            console.log(error);
        }).finally(function () {
            setLoadData(false);
        });
    }


    const reste = (service, jour) => {
        if (service !== "") {
            if (service === "petitDejeuner") {
                const capaciterPdejeuner = sansOffreMenu.find(el => el.name === "petitDejeuner")?.[jour.toLowerCase()] || "";
                return capaciterPdejeuner;

            } else if (service === "dejeuner") {
                const capaciterDejeuner = sansOffreMenu.find(el => el.name === "dejeuner")?.[jour.toLowerCase()] || "";
                return capaciterDejeuner;

            } else {
                const capaciterDiner = sansOffreMenu.find(el => el.name === "diner")?.[jour.toLowerCase()] || "";
                return capaciterDiner;
            }
        } else {
            return 0;
        }

    }



    const viewPromo50 = () => {
        const donnerPromo50 = dataPromo.filter((el) => el.name === "promo50");
        return (
            donnerPromo50.length !== 0 ?
                donnerPromo50.map((el, index) => {
                    return (
                        <div className='reponsePromo' key={index}>
                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                <div>
                                    <div className='d-flex flex-column'>
                                        <Select
                                            placeholder={el.service === "" ? "Service ..." : el.service}
                                            onChange={(e) => handleChangeServicePromo50(e.value, el.id)}
                                            options={options} />

                                    </div>
                                </div>
                                <div >
                                    <i className='fa fa-trash-o' onClick={() => handleDeletePromo50(el.id)}></i>
                                </div>
                            </div>
                            {el.error !== "" ? <p className='errorValue'>{el.error}</p> : ''}
                            <div className='capaciter_jour'>
                                <div className='capaciter_jour_libelle'>
                                    <span>Lu</span>
                                    <span>Ma</span>
                                    <span>Me</span>
                                    <span>Jeu</span>
                                    <span>Ve</span>
                                    <span>Sa</span>
                                    <span>Di</span>
                                </div>
                                <div className='capaciter_number'>
                                    <input type="number" onKeyDown={(e) => blockInvalidChar(e, el.id, el.service)} defaultValue={el.lundi} onChange={(e) => handleChangePromo50(e.target.value, el.id, el.service, "lundi")} className='form-control' placeholder='0' />
                                    <input type="number" onKeyDown={(e) => blockInvalidChar(e, el.id, el.service)} defaultValue={el.mardi} onChange={(e) => handleChangePromo50(e.target.value, el.id, el.service, "mardi")} className='form-control' placeholder='0' />
                                    <input type="number" onKeyDown={(e) => blockInvalidChar(e, el.id, el.service)} defaultValue={el.mercredi} onChange={(e) => handleChangePromo50(e.target.value, el.id, el.service, "mercredi")} className='form-control' placeholder='0' />
                                    <input type="number" onKeyDown={(e) => blockInvalidChar(e, el.id, el.service)} defaultValue={el.jeudi} onChange={(e) => handleChangePromo50(e.target.value, el.id, el.service, "jeudi")} className='form-control' placeholder='0' />
                                    <input type="number" onKeyDown={(e) => blockInvalidChar(e, el.id, el.service)} defaultValue={el.vendredi} onChange={(e) => handleChangePromo50(e.target.value, el.id, el.service, "vendredi")} className='form-control' placeholder='0' />
                                    <input type="number" onKeyDown={(e) => blockInvalidChar(e, el.id, el.service)} defaultValue={el.samedi} onChange={(e) => handleChangePromo50(e.target.value, el.id, el.service, "samedi")} className='form-control' placeholder='0' />
                                    <input type="number" onKeyDown={(e) => blockInvalidChar(e, el.id, el.service)} defaultValue={el.dimanche} onChange={(e) => handleChangePromo50(e.target.value, el.id, el.service, "dimanche")} className='form-control' placeholder='0' />
                                </div>
                            </div>

                        </div>
                    );
                })

                : <p className='errorValue'>Promo -50% vide...</p>

        )
    }



    const handleChangeServicePromo50 = (value, id) => {
        const donnerPromo50 = dataPromo.filter((el) => el.name === "promo50");
        const filter = info.find((el) => el.service === value);
        console.log(filter);
        const existeValue = donnerPromo50.find((el) => el.service === value && el.id !== id);
        if (existeValue) {
            setError50('Les services dans un promotion doit être différentes !');
            const timer = setTimeout(() => setError50(''), 3000);
            return () => clearTimeout(timer);

        } else {
            setDataPromo((prev) => {
                return prev.map((item) => {
                    if (item.id === id) {
                        if (item.service === value) {
                            return { ...item };
                        } else {
                            return { ...item, service: value, capaciter: filter?.capaciter, error: "" };
                        }
                    } else {
                        return { ...item };
                    }
                });
            });
        }

    }

    const handleDeletePromo50 = (id) => {
        setDataPromo(dataPromo.filter((el) => el.id !== id));
    }


    const handleChangePromo50 = (value, id, service, jour) => {
        const valueControlReste = reste(service, jour);

        if (valueControlReste === null || isNaN(valueControlReste)) {
            toast.warning("Vous devez d'abord remplir ou modifier les données dans la page d'information.");
            return;
        }

        const valeurEntree = safeParseFloat(value);
        if (isNaN(valeurEntree)) {
            toast.warning("Veuillez entrer une valeur numérique valide.");
            return;
        }

        const resteCapacite = safeParseFloat(valueControlReste) - valeurEntree;

        if (resteCapacite >= 0) {
            setDataPromo((prev) =>
                prev.map((item) => {
                    if (item.id === id) {
                        if (item.service !== "") {
                            if (valeurEntree < 1) {
                                return { ...item, [jour]: 0, error: "" };
                            } else {
                                return { ...item, [jour]: valeurEntree, error: "" };
                            }
                        } else {
                            return { ...item, error: "Veuillez sélectionner un service." };
                        }
                    }
                    return item;
                })
            );
        } else {
            toast.warning(`Cette valeur dépasse la capacité restante pour le service ${service}. Veuillez la modifier.`);
        }
    };

    const handleAddPromo40 = () => {
        if (info.length === 0) {
            toast.success("Remplisez d'abord les informations du resto dans l'ongle info générales");
        } else {
            const donnerPromo40 = dataPromo.filter((el) => el.name === "promo40");
            console.log(donnerPromo40.length);
            if (donnerPromo40.length < 3) {
                setError40('');
                setDataPromo((prev) => [...prev, {
                    id: dataPromo.length + 1, name: "promo40", service: "", capaciter: "",
                    lundi: "", mardi: "", mercredi: "", jeudi: "", vendredi: "", samedi: "", dimanche: "", error: ""
                }]);
            } else {
                setError40('Promotion -40% max 3');
                const timer = setTimeout(() => setError40(''), 3000);
                return () => clearTimeout(timer);
            }
        }
    }

    const viewPromo40 = () => {
        const donnerPromo40 = dataPromo.filter((el) => el.name === "promo40");
        return (
            donnerPromo40.length !== 0 ?
                donnerPromo40.map((el, index) => {
                    return (
                        <div className='reponsePromo' key={index}>
                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                <div >
                                    <div className='d-flex flex-column'>
                                        <Select
                                            placeholder={el.service === "" ? "Service ..." : el.service}
                                            onChange={(e) => handleChangeServicePromo40(e.value, el.id)}
                                            options={options} />

                                    </div>
                                </div>
                                <div >
                                    <i className='fa fa-trash-o' onClick={() => handleDeletePromo40(el.id)}></i>
                                </div>

                            </div>
                            {el.error !== "" ? <p className='errorValue'>{el.error}</p> : ''}
                            <div className='capaciter_jour'>
                                <div className='capaciter_jour_libelle'>
                                    <span>Lu</span>
                                    <span>Ma</span>
                                    <span>Me</span>
                                    <span>Jeu</span>
                                    <span>Ve</span>
                                    <span>Sa</span>
                                    <span>Di</span>
                                </div>

                                <div className='capaciter_number'>
                                    <input type="number" onKeyDown={(e) => blockInvalidChar(e, el.id, el.service)} defaultValue={el.lundi} onChange={(e) => handleChangePromo40(e.target.value, el.id, el.service, "lundi")} className='form-control' placeholder='0' />
                                    <input type="number" onKeyDown={(e) => blockInvalidChar(e, el.id, el.service)} defaultValue={el.mardi} onChange={(e) => handleChangePromo40(e.target.value, el.id, el.service, "mardi")} className='form-control' placeholder='0' />
                                    <input type="number" onKeyDown={(e) => blockInvalidChar(e, el.id, el.service)} defaultValue={el.mercredi} onChange={(e) => handleChangePromo40(e.target.value, el.id, el.service, "mercredi")} className='form-control' placeholder='0' />
                                    <input type="number" onKeyDown={(e) => blockInvalidChar(e, el.id, el.service)} defaultValue={el.jeudi} onChange={(e) => handleChangePromo40(e.target.value, el.id, el.service, "jeudi")} className='form-control' placeholder='0' />
                                    <input type="number" onKeyDown={(e) => blockInvalidChar(e, el.id, el.service)} defaultValue={el.vendredi} onChange={(e) => handleChangePromo40(e.target.value, el.id, el.service, "vendredi")} className='form-control' placeholder='0' />
                                    <input type="number" onKeyDown={(e) => blockInvalidChar(e, el.id, el.service)} defaultValue={el.samedi} onChange={(e) => handleChangePromo40(e.target.value, el.id, el.service, "samedi")} className='form-control' placeholder='0' />
                                    <input type="number" onKeyDown={(e) => blockInvalidChar(e, el.id, el.service)} defaultValue={el.dimanche} onChange={(e) => handleChangePromo40(e.target.value, el.id, el.service, "dimanche")} className='form-control' placeholder='0' />
                                </div>
                            </div>

                        </div>
                    )
                }) : <p className='errorValue'>Promo -40% vide...</p>

        );
    }


    const handleDeletePromo40 = (id) => {
        setDataPromo(dataPromo.filter((el) => el.id !== id));
    }


    const handleChangeServicePromo40 = (value, id) => {
        const donnerPromo40 = dataPromo.filter((el) => el.name === "promo40");
        const filter = info.find((el) => el.service === value);
        console.log(filter);
        const existeValue = donnerPromo40.find((el) => el.service === value && el.id !== id);
        if (existeValue) {
            setError40('Les services dans un promotion doit être différentes !');
            const timer = setTimeout(() => setError40(''), 3000);

            return () => clearTimeout(timer);

        } else {
            setDataPromo((prev) => {
                return prev.map((item) => {
                    if (item.id === id) {
                        if (item.service === value) {
                            return { ...item };
                        } else {
                            return { ...item, service: value, capaciter: filter?.capaciter, error: "" };
                        }
                    } else {
                        return { ...item };
                    }
                });
            });
        }
    }

    const handleChangePromo40 = (value, id, service, jour) => {
        const valueControlReste = reste(service, jour);

        if (valueControlReste === null || isNaN(valueControlReste)) {
            toast.warning("Vous devez d'abord remplir ou modifier les données dans la page d'information.");
            return;
        }

        const valeurEntree = safeParseFloat(value);
        if (isNaN(valeurEntree)) {
            toast.warning("Veuillez entrer une valeur numérique valide.");
            return;
        }

        const resteCapacite = safeParseFloat(valueControlReste) - valeurEntree;

        if (resteCapacite >= 0) {
            setDataPromo((prev) => {
                return prev.map((item) => {
                    if (item.id === id) {
                        if (item.service !== "") {
                            if (value < 1) {
                                return { ...item, [jour]: 0 };
                            } else {
                                return { ...item, [jour]: value, error: "" };
                            }
                        } else {
                            return { ...item, error: "Select service" };
                        }

                    } else {
                        return { ...item };
                    }
                });
            });
        } else {
            toast.warning(`Cette valeur épuise la capaciter du ${service}, vous devez le changer!`);
        }
    }


    const handleAddPromo30 = () => {
        if (info.length === 0) {
            toast.success("Remplisez d'abord les informations du resto dans l'ongle info générales");
        } else {
            const donnerPromo30 = dataPromo.filter((el) => el.name === "promo30");
            console.log(donnerPromo30.length);
            if (donnerPromo30.length < 3) {
                setError30('');
                setDataPromo((prev) => [...prev, {
                    id: dataPromo.length + 1, name: "promo30", service: "", capaciter: "",
                    lundi: "", mardi: "", mercredi: "", jeudi: "", vendredi: "", samedi: "", dimanche: "", error: ""
                }]);
            } else {
                setError30('Promotion -30% max 3');
                const timer = setTimeout(() => setError30(''), 3000);
                return () => clearTimeout(timer);
            }
        }
    }

    const viewPromo30 = () => {
        const donnerPromo30 = dataPromo.filter((el) => el.name === "promo30");
        return (
            donnerPromo30.length !== 0 ?
                donnerPromo30.map((el, index) => {
                    return (
                        <div className='reponsePromo' key={index}>
                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                <div >
                                    <div className='d-flex flex-column'>
                                        <Select
                                            placeholder={el.service === "" ? "Service ..." : el.service}
                                            onChange={(e) => handleChangeServicePromo30(e.value, el.id)}
                                            options={options} />

                                    </div>
                                </div>
                                <div >
                                    <i className='fa fa-trash-o' onClick={() => handleDeletePromo30(el.id)}></i>
                                </div>

                            </div>
                            {el.error !== "" ? <p className='errorValue'>{el.error}</p> : ''}
                            <div className='capaciter_jour'>
                                <div className='capaciter_jour_libelle'>
                                    <span>Lu</span>
                                    <span>Ma</span>
                                    <span>Me</span>
                                    <span>Jeu</span>
                                    <span>Ve</span>
                                    <span>Sa</span>
                                    <span>Di</span>
                                </div>

                                <div className='capaciter_number'>
                                    <input type="number" onKeyDown={(e) => blockInvalidChar(e, el.id, el.service)} defaultValue={el.lundi} onChange={(e) => handleChangePromo30(e.target.value, el.id, el.service, "lundi")} className='form-control' placeholder='0' />
                                    <input type="number" onKeyDown={(e) => blockInvalidChar(e, el.id, el.service)} defaultValue={el.mardi} onChange={(e) => handleChangePromo30(e.target.value, el.id, el.service, "mardi")} className='form-control' placeholder='0' />
                                    <input type="number" onKeyDown={(e) => blockInvalidChar(e, el.id, el.service)} defaultValue={el.mercredi} onChange={(e) => handleChangePromo30(e.target.value, el.id, el.service, "mercredi")} className='form-control' placeholder='0' />
                                    <input type="number" onKeyDown={(e) => blockInvalidChar(e, el.id, el.service)} defaultValue={el.jeudi} onChange={(e) => handleChangePromo30(e.target.value, el.id, el.service, "jeudi")} className='form-control' placeholder='0' />
                                    <input type="number" onKeyDown={(e) => blockInvalidChar(e, el.id, el.service)} defaultValue={el.vendredi} onChange={(e) => handleChangePromo30(e.target.value, el.id, el.service, "vendredi")} className='form-control' placeholder='0' />
                                    <input type="number" onKeyDown={(e) => blockInvalidChar(e, el.id, el.service)} defaultValue={el.samedi} onChange={(e) => handleChangePromo30(e.target.value, el.id, el.service, "samedi")} className='form-control' placeholder='0' />
                                    <input type="number" onKeyDown={(e) => blockInvalidChar(e, el.id, el.service)} defaultValue={el.dimanche} onChange={(e) => handleChangePromo30(e.target.value, el.id, el.service, "dimanche")} className='form-control' placeholder='0' />
                                </div>
                            </div>

                        </div>
                    )
                }) : <p className='errorValue'>Promo -30% vide...</p>

        );
    }

    const handleDeletePromo30 = (id) => {
        setDataPromo(dataPromo.filter((el) => el.id !== id));
    }

    const handleChangeServicePromo30 = (value, id) => {
        const donnerPromo30 = dataPromo.filter((el) => el.name === "promo30");
        const filter = info.find((el) => el.service === value);
        console.log(filter);
        const existeValue = donnerPromo30.find((el) => el.service === value && el.id !== id);
        if (existeValue) {
            setError30('Les services dans un promotion doit être différentes !');
            const timer = setTimeout(() => setError30(''), 3000);

            return () => clearTimeout(timer);
        } else {
            setDataPromo((prev) => {
                return prev.map((item) => {
                    if (item.id === id) {
                        if (item.service === value) {
                            return { ...item };
                        } else {
                            return { ...item, service: value, capaciter: filter?.capaciter, error: "" };
                        }
                    } else {
                        return { ...item };
                    }
                });
            });
        }
    }

    const handleChangePromo30 = (value, id, service, jour) => {
        const valueControlReste = reste(service, jour);

        if (valueControlReste === null || isNaN(valueControlReste)) {
            toast.warning("Vous devez d'abord remplir ou modifier les données dans la page d'information.");
            return;
        }

        const valeurEntree = safeParseFloat(value);
        if (isNaN(valeurEntree)) {
            toast.warning("Veuillez entrer une valeur numérique valide.");
            return;
        }

        const resteCapacite = safeParseFloat(valueControlReste) - valeurEntree;

        if (resteCapacite >= 0) {
            setDataPromo((prev) => {
                return prev.map((item) => {
                    if (item.id === id) {
                        if (item.service !== "") {
                            if (value < 1) {
                                return { ...item, [jour]: 0 };
                            } else {
                                return { ...item, [jour]: value, error: "" };
                            }
                        } else {
                            return { ...item, error: "Select service" };
                        }

                    } else {
                        return { ...item };
                    }
                });
            });
        } else {
            toast.warning(`Cette valeur épuise la capaciter du ${service}, vous devez le changer!`);
        }
    }


    const handleAddPromo20 = () => {
        if (info.length === 0) {
            toast.success("Remplisez d'abord les informations du resto dans l'ongle info générales");
        } else {
            const donnerPromo20 = dataPromo.filter((el) => el.name === "promo20");
            console.log(donnerPromo20.length);
            if (donnerPromo20.length < 3) {
                setError20('');
                setDataPromo((prev) => [...prev, {
                    id: dataPromo.length + 1, name: "promo20", service: "", capaciter: "",
                    lundi: "", mardi: "", mercredi: "", jeudi: "", vendredi: "", samedi: "", dimanche: "", error: ""
                }]);
            } else {
                setError20('Promotion -20% max 3');
                const timer = setTimeout(() => setError20(''), 3000);
                return () => clearTimeout(timer);
            }
        }

    }


    const viewPromo20 = () => {
        const donnerPromo20 = dataPromo.filter((el) => el.name === "promo20");
        return (
            donnerPromo20.length !== 0 ?
                donnerPromo20.map((el, index) => {
                    return (
                        <div className='reponsePromo' key={index}>
                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                <div >
                                    <div className='d-flex flex-column'>
                                        <Select
                                            placeholder={el.service === "" ? "Service ..." : el.service}
                                            onChange={(e) => handleChangeServicePromo20(e.value, el.id)}
                                            options={options} />

                                    </div>
                                </div>
                                <div>
                                    <i className='fa fa-trash-o' onClick={() => handleDeletePromo20(el.id)}></i>
                                </div>

                            </div>
                            {el.error !== "" ? <p className='errorValue'>{el.error}</p> : ''}
                            <div className='capaciter_jour'>
                                <div className='capaciter_jour_libelle'>
                                    <span>Lu</span>
                                    <span>Ma</span>
                                    <span>Me</span>
                                    <span>Jeu</span>
                                    <span>Ve</span>
                                    <span>Sa</span>
                                    <span>Di</span>
                                </div>

                                <div className='capaciter_number'>
                                    <input type="number" onKeyDown={(e) => blockInvalidChar(e, el.id, el.service)} defaultValue={el.lundi} onChange={(e) => handleChangePromo20(e.target.value, el.id, el.service, "lundi")} className='form-control' placeholder='0' />
                                    <input type="number" onKeyDown={(e) => blockInvalidChar(e, el.id, el.service)} defaultValue={el.mardi} onChange={(e) => handleChangePromo20(e.target.value, el.id, el.service, "mardi")} className='form-control' placeholder='0' />
                                    <input type="number" onKeyDown={(e) => blockInvalidChar(e, el.id, el.service)} defaultValue={el.mercredi} onChange={(e) => handleChangePromo20(e.target.value, el.id, el.service, "mercredi")} className='form-control' placeholder='0' />
                                    <input type="number" onKeyDown={(e) => blockInvalidChar(e, el.id, el.service)} defaultValue={el.jeudi} onChange={(e) => handleChangePromo20(e.target.value, el.id, el.service, "jeudi")} className='form-control' placeholder='0' />
                                    <input type="number" onKeyDown={(e) => blockInvalidChar(e, el.id, el.service)} defaultValue={el.vendredi} onChange={(e) => handleChangePromo20(e.target.value, el.id, el.service, "vendredi")} className='form-control' placeholder='0' />
                                    <input type="number" onKeyDown={(e) => blockInvalidChar(e, el.id, el.service)} defaultValue={el.samedi} onChange={(e) => handleChangePromo20(e.target.value, el.id, el.service, "samedi")} className='form-control' placeholder='0' />
                                    <input type="number" onKeyDown={(e) => blockInvalidChar(e, el.id, el.service)} defaultValue={el.dimanche} onChange={(e) => handleChangePromo20(e.target.value, el.id, el.service, "dimanche")} className='form-control' placeholder='0' />
                                </div>
                            </div>

                        </div>
                    )
                }) : <p className='errorValue'>Promo -20% vide...</p>

        );
    }


    const handleDeletePromo20 = (id) => {
        setDataPromo(dataPromo.filter((el) => el.id !== id));
    }


    const handleChangeServicePromo20 = (value, id) => {
        const donnerPromo20 = dataPromo.filter((el) => el.name === "promo20");
        const filter = info.find((el) => el.service === value);
        console.log(filter);
        const existeValue = donnerPromo20.find((el) => el.service === value && el.id !== id);
        if (existeValue) {
            setError20('Les services dans un promotion doit être différentes !');
            const timer = setTimeout(() => setError20(''), 3000);

            return () => clearTimeout(timer);
        } else {
            setDataPromo((prev) => {
                return prev.map((item) => {
                    if (item.id === id) {
                        if (item.service === value) {
                            return { ...item };
                        } else {
                            return { ...item, service: value, capaciter: filter?.capaciter, error: "" };
                        }
                    } else {
                        return { ...item };
                    }
                });
            });
        }
    }

    const handleChangePromo20 = (value, id, service, jour) => {
        const valueControlReste = reste(service, jour);

        if (valueControlReste === null || isNaN(valueControlReste)) {
            toast.warning("Vous devez d'abord remplir ou modifier les données dans la page d'information.");
            return;
        }

        const valeurEntree = safeParseFloat(value);
        if (isNaN(valeurEntree)) {
            toast.warning("Veuillez entrer une valeur numérique valide.");
            return;
        }

        const resteCapacite = safeParseFloat(valueControlReste) - valeurEntree;

        if (resteCapacite >= 0) {
            setDataPromo((prev) => {
                return prev.map((item) => {
                    if (item.id === id) {
                        if (item.service !== "") {
                            if (value < 1) {
                                return { ...item, [jour]: 0 };
                            } else {
                                return { ...item, [jour]: value, error: "" };
                            }
                        } else {
                            return { ...item, error: "Select service" };
                        }

                    } else {
                        return { ...item };
                    }
                });
            });
        } else {
            toast.warning(`Cette valeur épuise la capaciter du ${service}, vous devez le changer!`);
        }
    }


    const handleAddPromo10 = () => {
        if (info.length === 0) {
            toast.success("Remplisez d'abord les informations du resto dans l'ongle info générales");
        } else {
            const donnerPromo10 = dataPromo.filter((el) => el.name === "promo10");
            console.log(donnerPromo10.length);
            if (donnerPromo10.length < 3) {
                setError10('');
                setDataPromo((prev) => [...prev, {
                    id: dataPromo.length + 1, name: "promo10", service: "", capaciter: "",
                    lundi: "", mardi: "", mercredi: "", jeudi: "", vendredi: "", samedi: "", dimanche: "", error: ""
                }]);
            } else {
                setError10('Promotion -10% max 3');
                const timer = setTimeout(() => setError10(''), 3000);
                return () => clearTimeout(timer);
            }
        }
    }


    const viewPromo10 = () => {
        const donnerPromo10 = dataPromo.filter((el) => el.name === "promo10");
        return (
            donnerPromo10.length !== 0 ?
                donnerPromo10.map((el, index) => {
                    return (
                        <div className='reponsePromo' key={index}>
                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                <div >
                                    <div className='d-flex flex-column'>
                                        <Select
                                            placeholder={el.service === "" ? "Service ..." : el.service}
                                            onChange={(e) => handleChangeServicePromo10(e.value, el.id)}
                                            options={options} />

                                    </div>
                                </div>
                                <div >
                                    <i className='fa fa-trash-o' onClick={() => handleDeletePromo10(el.id)}></i>
                                </div>

                            </div>
                            {el.error !== "" ? <p className='errorValue'>{el.error}</p> : ''}
                            <div className='capaciter_jour'>
                                <div className='capaciter_jour_libelle'>
                                    <span>Lu</span>
                                    <span>Ma</span>
                                    <span>Me</span>
                                    <span>Jeu</span>
                                    <span>Ve</span>
                                    <span>Sa</span>
                                    <span>Di</span>
                                </div>

                                <div className='capaciter_number'>
                                    <input type="number" onKeyDown={(e) => blockInvalidChar(e, el.id, el.service)} defaultValue={el.lundi} onChange={(e) => handleChangePromo10(e.target.value, el.id, el.service, "lundi")} className='form-control' placeholder='0' />
                                    <input type="number" onKeyDown={(e) => blockInvalidChar(e, el.id, el.service)} defaultValue={el.mardi} onChange={(e) => handleChangePromo10(e.target.value, el.id, el.service, "mardi")} className='form-control' placeholder='0' />
                                    <input type="number" onKeyDown={(e) => blockInvalidChar(e, el.id, el.service)} defaultValue={el.mercredi} onChange={(e) => handleChangePromo10(e.target.value, el.id, el.service, "mercredi")} className='form-control' placeholder='0' />
                                    <input type="number" onKeyDown={(e) => blockInvalidChar(e, el.id, el.service)} defaultValue={el.jeudi} onChange={(e) => handleChangePromo10(e.target.value, el.id, el.service, "jeudi")} className='form-control' placeholder='0' />
                                    <input type="number" onKeyDown={(e) => blockInvalidChar(e, el.id, el.service)} defaultValue={el.vendredi} onChange={(e) => handleChangePromo10(e.target.value, el.id, el.service, "vendredi")} className='form-control' placeholder='0' />
                                    <input type="number" onKeyDown={(e) => blockInvalidChar(e, el.id, el.service)} defaultValue={el.samedi} onChange={(e) => handleChangePromo10(e.target.value, el.id, el.service, "samedi")} className='form-control' placeholder='0' />
                                    <input type="number" onKeyDown={(e) => blockInvalidChar(e, el.id, el.service)} defaultValue={el.dimanche} onChange={(e) => handleChangePromo10(e.target.value, el.id, el.service, "dimanche")} className='form-control' placeholder='0' />
                                </div>
                            </div>

                        </div>
                    )
                }) : <p className='errorValue'>Promo -10% vide...</p>

        );
    }


    const handleDeletePromo10 = (id) => {
        setDataPromo(dataPromo.filter((el) => el.id !== id));
    }



    const handleChangeServicePromo10 = (value, id) => {
        const donnerPromo10 = dataPromo.filter((el) => el.name === "promo10");
        const filter = info.find((el) => el.service === value);
        console.log(filter);
        const existeValue = donnerPromo10.find((el) => el.service === value && el.id !== id);
        if (existeValue) {
            setError10('Les services dans un promotion doit être différentes !');
            const timer = setTimeout(() => setError10(''), 3000);

            return () => clearTimeout(timer);
        } else {
            setDataPromo((prev) => {
                return prev.map((item) => {
                    if (item.id === id) {
                        if (item.service === value) {
                            return { ...item };
                        } else {
                            return { ...item, service: value, capaciter: filter?.capaciter, error: "" };
                        }
                    } else {
                        return { ...item };
                    }
                });
            });
        }
    }

    const handleChangePromo10 = (value, id, service, jour) => {
        const valueControlReste = reste(service, jour);

        if (valueControlReste === null || isNaN(valueControlReste)) {
            toast.warning("Vous devez d'abord remplir ou modifier les données dans la page d'information.");
            return;
        }

        const valeurEntree = safeParseFloat(value);
        if (isNaN(valeurEntree)) {
            toast.warning("Veuillez entrer une valeur numérique valide.");
            return;
        }

        const resteCapacite = safeParseFloat(valueControlReste) - valeurEntree;

        if (resteCapacite >= 0) {
            setDataPromo((prev) => {
                return prev.map((item) => {
                    if (item.id === id) {
                        if (item.service !== "") {
                            if (value < 1) {
                                return { ...item, [jour]: 0 };
                            } else {
                                return { ...item, [jour]: value, error: "" };
                            }
                        } else {
                            return { ...item, error: "Select service" };
                        }

                    } else {
                        return { ...item };
                    }
                });
            });
        } else {
            toast.warning(`Cette valeur épuise la capaciter du ${service}, vous devez le changer!`);
        }
    }

    const handleAddSpecial = () => {
        if (info.length === 0) {
            toast.success("Remplisez d'abord les informations du resto dans l'ongle info générales");
        } else {
            const donnerSpecial = dataPromo.filter((el) => el.name === "special");
            console.log(donnerSpecial.length);
            if (donnerSpecial.length < 3) {
                setErrorSpecial('');
                setDataPromo((prev) => [...prev, {
                    id: dataPromo.length + 1, name: "special", service: "", capaciter: "",
                    lundi: "", mardi: "", mercredi: "", jeudi: "", vendredi: "", samedi: "", dimanche: "", error: ""
                }]);
            } else {
                setErrorSpecial('Menu spécial site max 3');
                const timer = setTimeout(() => setErrorSpecial(''), 3000);
                return () => clearTimeout(timer);
            }
        }
    }


    const viewSpecial = () => {
        const donnerSpecial = dataPromo.filter((el) => el.name === "special");
        return (
            donnerSpecial.length !== 0 ?
                donnerSpecial.map((el, index) => {
                    return (
                        <div className='reponsePromo' key={index}>
                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                <div >
                                    <div className='d-flex flex-column'>
                                        <Select
                                            placeholder={el.service === "" ? "Service ..." : el.service}
                                            onChange={(e) => handleChangeServiceSpecial(e.value, el.id)}
                                            options={options} />
                                    </div>
                                </div>
                                <div >
                                    <i className='fa fa-trash-o' onClick={() => handleDeleteSpecial(el.id)}></i>
                                </div>

                            </div>
                            {el.error !== "" ? <p className='errorValue'>{el.error}</p> : ''}
                            <div className='capaciter_jour'>
                                <div className='capaciter_jour_libelle'>
                                    <span>Lu</span>
                                    <span>Ma</span>
                                    <span>Me</span>
                                    <span>Jeu</span>
                                    <span>Ve</span>
                                    <span>Sa</span>
                                    <span>Di</span>
                                </div>
                                <div className='capaciter_number'>
                                    <input type="number" onKeyDown={(e) => blockInvalidChar(e, el.id, el.service)} defaultValue={el.lundi} onChange={(e) => handleChangeSpecial(e.target.value, el.id, el.service, "lundi")} className='form-control' placeholder='0' />
                                    <input type="number" onKeyDown={(e) => blockInvalidChar(e, el.id, el.service)} defaultValue={el.mardi} onChange={(e) => handleChangeSpecial(e.target.value, el.id, el.service, "mardi")} className='form-control' placeholder='0' />
                                    <input type="number" onKeyDown={(e) => blockInvalidChar(e, el.id, el.service)} defaultValue={el.mercredi} onChange={(e) => handleChangeSpecial(e.target.value, el.id, el.service, "mercredi")} className='form-control' placeholder='0' />
                                    <input type="number" onKeyDown={(e) => blockInvalidChar(e, el.id, el.service)} defaultValue={el.jeudi} onChange={(e) => handleChangeSpecial(e.target.value, el.id, el.service, "jeudi")} className='form-control' placeholder='0' />
                                    <input type="number" onKeyDown={(e) => blockInvalidChar(e, el.id, el.service)} defaultValue={el.vendredi} onChange={(e) => handleChangeSpecial(e.target.value, el.id, el.service, "vendredi")} className='form-control' placeholder='0' />
                                    <input type="number" onKeyDown={(e) => blockInvalidChar(e, el.id, el.service)} defaultValue={el.samedi} onChange={(e) => handleChangeSpecial(e.target.value, el.id, el.service, "samedi")} className='form-control' placeholder='0' />
                                    <input type="number" onKeyDown={(e) => blockInvalidChar(e, el.id, el.service)} defaultValue={el.dimanche} onChange={(e) => handleChangeSpecial(e.target.value, el.id, el.service, "dimanche")} className='form-control' placeholder='0' />
                                </div>
                            </div>

                        </div>
                    )
                }) : <p className='errorValue'>Menu spécial site vide...</p>

        );
    }




    const handleDeleteSpecial = (id) => {
        setDataPromo(dataPromo.filter((el) => el.id !== id));
    }



    const handleChangeServiceSpecial = (value, id) => {
        const donnerSpecial = dataPromo.filter((el) => el.name === "special");
        const filter = info.find((el) => el.service === value);
        console.log(filter);
        const existeValue = donnerSpecial.find((el) => el.service === value && el.id !== id);
        if (existeValue) {
            setErrorSpecial('Les services dans un promotion doit être différentes !');
            const timer = setTimeout(() => setErrorSpecial(''), 3000);
            return () => clearTimeout(timer);
        } else {
            setDataPromo((prev) => {
                return prev.map((item) => {
                    if (item.id === id) {
                        if (item.service === value) {
                            return { ...item };
                        } else {
                            return { ...item, service: value, capaciter: filter?.capaciter, error: "" };
                        }
                    } else {
                        return { ...item };
                    }
                });
            });
        }
    }




    const handleChangeSpecial = (value, id, service, jour) => {
        const valueControlReste = reste(service, jour);

        if (valueControlReste === null || isNaN(valueControlReste)) {
            toast.warning("Vous devez d'abord remplir ou modifier les données dans la page d'information.");
            return;
        }

        const valeurEntree = safeParseFloat(value);
        if (isNaN(valeurEntree)) {
            toast.warning("Veuillez entrer une valeur numérique valide.");
            return;
        }

        const resteCapacite = safeParseFloat(valueControlReste) - valeurEntree;

        if (resteCapacite >= 0) {
            setDataPromo((prev) => {
                return prev.map((item) => {
                    if (item.id === id) {
                        if (item.service !== "") {
                            if (value < 1) {
                                return { ...item, [jour]: 0 };
                            } else {
                                return { ...item, [jour]: value, error: "" };
                            }
                        } else {
                            return { ...item, error: "Select service" };
                        }

                    } else {
                        return { ...item };
                    }
                });
            });
        } else {
            toast.warning(`Cette valeur épuise la capaciter du ${service}, vous devez le changer!`);
        }
    }

    const viewSansOffre = () => {

        return (
            sansOffreMenu.map((el, index) => {
                return (
                    <div className='sans_offres' key={index}>
                        <div className='bloc_service'>
                            <div className='d-flex justify-content-between'>
                                <span className='service'>{el.name === "petitDejeuner" ? "Petit déjeuner" : el.name === "diner" ? "Diner" : "Déjeuner"}</span>
                            </div>
                            <div className='capaciter_jour'>
                                <div className='capaciter_jour_libelle'>
                                    <span>Lu</span>
                                    <span>Ma</span>
                                    <span>Me</span>
                                    <span>Jeu</span>
                                    <span>Ve</span>
                                    <span>Sa</span>
                                    <span>Di</span>
                                </div>
                                <div className='capaciter_number'>
                                    <input type="number" disabled defaultValue={el.lundi} className='form-control' placeholder='0' />
                                    <input type="number" disabled defaultValue={el.mardi} className='form-control' placeholder='0' />
                                    <input type="number" disabled defaultValue={el.mercredi} className='form-control' placeholder='0' />
                                    <input type="number" disabled defaultValue={el.jeudi} className='form-control' placeholder='0' />
                                    <input type="number" disabled defaultValue={el.vendredi} className='form-control' placeholder='0' />
                                    <input type="number" disabled defaultValue={el.samedi} className='form-control' placeholder='0' />
                                    <input type="number" disabled defaultValue={el.dimanche} className='form-control' placeholder='0' />
                                </div>
                            </div>

                        </div>
                    </div>
                )
            })

        );
    }

    const viewDirect = () => {
        return (
            reservationDirect.map((el, index) => {
                return (
                    <div className='sans_offres' key={index}>
                        <div className='bloc_service'>
                            <div className='d-flex justify-content-between'>
                                <span className='service'>{el.name === "petitDejeuner" ? "Petit déjeuner" : el.name === "diner" ? "Diner" : "Déjeuner"}</span>
                            </div>
                            <div className='capaciter_jour'>
                                <div className='capaciter_jour_libelle'>
                                    <span>Lu</span>
                                    <span>Ma</span>
                                    <span>Me</span>
                                    <span>Jeu</span>
                                    <span>Ve</span>
                                    <span>Sa</span>
                                    <span>Di</span>
                                </div>
                                <div className='capaciter_number'>
                                    <input type="number" onKeyDown={(e) => blockInvalidChar(e, el.id, el.name)} defaultValue={el.lundi} onChange={(e) => handleChangeDirect(e.target.value, el.id, el.name, "lundi")} className='form-control' placeholder='0' />
                                    <input type="number" onKeyDown={(e) => blockInvalidChar(e, el.id, el.name)} defaultValue={el.mardi} onChange={(e) => handleChangeDirect(e.target.value, el.id, el.name, "mardi")} className='form-control' placeholder='0' />
                                    <input type="number" onKeyDown={(e) => blockInvalidChar(e, el.id, el.name)} defaultValue={el.mercredi} onChange={(e) => handleChangeDirect(e.target.value, el.id, el.name, "mercredi")} className='form-control' placeholder='0' />
                                    <input type="number" onKeyDown={(e) => blockInvalidChar(e, el.id, el.name)} defaultValue={el.jeudi} onChange={(e) => handleChangeDirect(e.target.value, el.id, el.name, "jeudi")} className='form-control' placeholder='0' />
                                    <input type="number" onKeyDown={(e) => blockInvalidChar(e, el.id, el.name)} defaultValue={el.vendredi} onChange={(e) => handleChangeDirect(e.target.value, el.id, el.name, "vendredi")} className='form-control' placeholder='0' />
                                    <input type="number" onKeyDown={(e) => blockInvalidChar(e, el.id, el.name)} defaultValue={el.samedi} onChange={(e) => handleChangeDirect(e.target.value, el.id, el.name, "samedi")} className='form-control' placeholder='0' />
                                    <input type="number" onKeyDown={(e) => blockInvalidChar(e, el.id, el.name)} defaultValue={el.dimanche} onChange={(e) => handleChangeDirect(e.target.value, el.id, el.name, "dimanche")} className='form-control' placeholder='0' />
                                </div>
                            </div>

                        </div>


                    </div>
                )
            })

        );
    }


    const handleChangeDirect = (value, id, service, jour) => {
        const valueControlReste = reste(service, jour); // récupère la capacité restante pour le service et le jour

        if (valueControlReste === null || isNaN(valueControlReste)) {
            toast.warning("Vous devez d'abord remplir les données dans la page information.");
            return;
        }
        const valeurEntree = safeParseFloat(value);
        const resteCapacite = safeParseFloat(valueControlReste) - valeurEntree;

        if (resteCapacite >= 0) {
            setReservationDirect((prev) =>
                prev.map((item) =>
                    item.id === id
                        ? { ...item, [jour]: valeurEntree < 1 ? 0 : valeurEntree }
                        : item
                )
            );
        } else {
            toast.warning(`Cette valeur épuise ou dépasse la capacité du ${service}, vous devez la changer !`);
        }
    };

    console.log("promoMin",promoMin);

    const handleEnregistrer = () => {
        if (!localStorage.getItem('tokenSociete')) {
            const diffInMillis = au - du;
            const diffInDays = Math.floor(diffInMillis / (1000 * 60 * 60 * 24));

            if (diffInDays < promoMin) {
                setErrorAu(`La promotion doit être d'au moins ${promoMin} jour(s).`);
            } else {
                const promo = [{
                    status: statusPromo, du: dateFormat(du?.getDate()) + "-" + dateFormat(parseInt(du?.getMonth() + 1)) + "-" + du?.getFullYear(),
                    au: dateFormat(au?.getDate()) + "-" + dateFormat(parseInt(au?.getMonth() + 1)) + "-" + au?.getFullYear()
                }];

                setLoading(true);
                const data = {
                    idRestaurant: restaurant.id, creneau: promo, promo: dataPromo
                };
                AjouteParametragePromo(data).then(function (response) {
                    if (response.data.title === "success") {
                        toast.success(response.data?.message);
                        setDataPromo([]);
                        AfficheParametragePromotion();
                    }
                }).catch(function (error) {
                    console.log(error.response);
                    toast.warning(error.response.data?.message);
                }).finally(function () {

                    setLoading(false);
                });
                setErrorAu('');
            }

        } else {
            toast.warning("Vous n'êtes pas autorisé à modifier ces éléments");
        }

    }


    const handleEnregistrerSansOffre = () => {

        if (!localStorage.getItem('tokenSociete')) {
            setLoadingSansOffre(true);
            const data = {
                idRestaurant: restaurant.id, sansOffre: sansOffreMenu, direct: reservationDirect
            };
            AjouteSansOffre(data).then(function (response) {
                if (response.data.title === "success") {
                    toast.success(response.data?.message);
                }
            }).catch(function (error) {
                console.log(error.response);
                toast.warning(error.response.data?.message);
            }).finally(function () {
                AfficheSansOffreData();
                setLoadingSansOffre(false);
            });
        } else {
            toast.warning("Vous n'êtes pas autorisé à modifier ces éléments");
        }
    }




    return (
        <div>
            <Helmet>
                <title>Offres promo</title>
                <meta name='description' content='Restaurant offres promo .' />
                <link rel='canonical' href={location.pathname} />
            </Helmet>
            <div className='offre_promo'>
                <div className='container'>
                    <div className='content_offre'>
                        <div className='titre_offre'>
                            <div className='d-flex mt-2 titre'>
                                <i className='fa fa-cogs'></i> <h1>Paramétrage des offres promotionnelles</h1>
                            </div>
                            <div className='offre_renseignement'>
                                <p>Saisir le nombre de couvert alloué à une promo par service, et par jour.
                                    Les offres doivent être paramétrées pour une période minimum de 2 semaines. Proposez la promotion la plus importante sur le jour et service pour lequel la fréquentation du restaurant est faible pour booster vos chiffres !!
                                </p>
                            </div>
                        </div>
                        <div className='bloc_offre'>
                            <div className='promotionParametrage'>
                                <div className='creneauPromotion'>
                                    {loadData === true ?
                                        <div className="d-flex justify-content-center">
                                            <Spinner animation="border" className="load" variant="info" size="md" />
                                        </div> : ''}
                                    <div className='ajoute_creneau d-flex justify-content-between'>
                                        <Form>
                                            <Form.Check
                                                type="switch"
                                                value={statusPromo}
                                                checked={statusPromo}
                                                label={statusPromo ? "Activer" : "Desactiver"}
                                                onChange={() => setStatusPromo(!statusPromo)}
                                            />
                                        </Form>

                                        <div className='d-flex'>
                                            <MuiPickersUtilsProvider locale={fr} utils={DateFnsUtils}>
                                                <span className='lettre me-2'>Du</span>
                                                <div className="d-flex flex-column">
                                                    <KeyboardDatePicker
                                                        value={du}
                                                        placeholder="10/10/2018"
                                                        onChange={date => setDu(date)}

                                                        format="dd/MM/yyyy"
                                                    />
                                                    {errorDu !== "" ? <span className='errorValue ms-1 mt-1'>{errorDu}</span> : ""}
                                                </div>

                                                <span className='lettre mx-2'>au</span>
                                                <div className="d-flex flex-column">
                                                    <KeyboardDatePicker
                                                        value={au}
                                                        placeholder="10/10/2018"
                                                        onChange={handleEndPromo}

                                                        format="dd/MM/yyyy"
                                                    />
                                                    {errorAu !== "" ? <span className='errorValue ms-1 mt-1'>{errorAu}</span> : ""}
                                                </div>

                                            </MuiPickersUtilsProvider>
                                        </div>
                                        <h2>Etat : {statusPromo === true && au >= new Date() ? <span>en cours</span> : statusPromo === false ? <span>Desactiver</span> : <span>Expirée</span>}</h2>

                                    </div>
                                    {promoMin ? 
                                    <div className='d-flex justify-content-center'>
                                        <p style={{fontSize:'14px',color:'white', fontWeight:500, marginBottom:'5px', marginTop:'10px'}}>Promotions valables pour un minimum de {promoMin} jours</p>
                                    </div>
                                    :''}
                                    
                                    <div className='row'>
                                        <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4'>
                                            <div className='bloc_promo'>
                                                <div className='titre_promo'>
                                                    <div className='d-flex justify-content-between'>
                                                        <div className='d-flex'>
                                                            <i className='fa fa-bookmark'></i>
                                                            <h3>Promo : -50% sur la carte</h3>
                                                        </div>
                                                        <div className=''>
                                                            <button className='btn btn-sm add_service' onClick={() => handleAddPromo50()}> <i className='fa fa-plus'></i></button>
                                                        </div>
                                                    </div>
                                                </div>
                                                {error50 !== "" ? <p className='errorValue'>{error50}</p> : ''}
                                                {viewPromo50()}
                                            </div>
                                        </div>
                                        <div className='col-12 col-sm-12 col-md-6 col-lg-6  col-xl-4'>
                                            <div className='bloc_promo'>
                                                <div className='titre_promo'>
                                                    <div className='d-flex justify-content-between'>
                                                        <div className='d-flex'>
                                                            <i className='fa fa-bookmark'></i>
                                                            <h3>Promo : -40% sur la carte</h3>
                                                        </div>
                                                        <div className=''>
                                                            <button className='btn btn-sm add_service' onClick={() => handleAddPromo40()}><i className='fa fa-plus'></i></button>
                                                        </div>
                                                    </div>
                                                </div>
                                                {error40 !== "" ? <p className='errorValue'>{error40}</p> : ''}
                                                {viewPromo40()}
                                            </div>
                                        </div>
                                        <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 promo30'>
                                            <div className='bloc_promo'>
                                                <div className='titre_promo'>
                                                    <div className='d-flex justify-content-between'>
                                                        <div className='d-flex'>
                                                            <i className='fa fa-bookmark'></i>
                                                            <h3>Promo : -30% sur la carte</h3>
                                                        </div>
                                                        <div className=''>
                                                            <button className='btn btn-sm add_service' onClick={() => handleAddPromo30()} ><i className='fa fa-plus'></i></button>
                                                        </div>
                                                    </div>
                                                </div>
                                                {error30 !== "" ? <p className='errorValue'>{error30}</p> : ''}
                                                {viewPromo30()}
                                            </div>
                                        </div>
                                        <div className='col-12 col-sm-12 col-md-6 col-lg-6  col-xl-4 mt-3'>
                                            <div className='bloc_promo'>
                                                <div className='titre_promo'>
                                                    <div className='d-flex justify-content-between'>
                                                        <div className='d-flex'>
                                                            <i className='fa fa-bookmark'></i>
                                                            <h3>Promo : -20% sur la carte</h3>
                                                        </div>
                                                        <div className=''>
                                                            <button className='btn btn-sm add_service' onClick={() => handleAddPromo20()}><i className='fa fa-plus'></i></button>
                                                        </div>
                                                    </div>
                                                </div>
                                                {error20 !== "" ? <p className='errorValue'>{error20}</p> : ''}
                                                {viewPromo20()}
                                            </div>
                                        </div>
                                        <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 mt-3'>
                                            <div className='bloc_promo'>
                                                <div className='titre_promo'>
                                                    <div className='d-flex justify-content-between'>
                                                        <div className='d-flex'>
                                                            <i className='fa fa-bookmark'></i>
                                                            <h3>Promo : -10% sur la carte</h3>
                                                        </div>
                                                        <div className=''>
                                                            <button className='btn btn-sm add_service' onClick={() => handleAddPromo10()}><i className='fa fa-plus'></i></button>
                                                        </div>
                                                    </div>
                                                </div>
                                                {error10 !== "" ? <p className='errorValue'>{error10}</p> : ''}
                                                {viewPromo10()}
                                            </div>
                                        </div>
                                        <div className='col-12 col-sm-12 col-md-6 col-lg-6  col-xl-4 mt-3'>
                                            <div className='bloc_promo'>
                                                <div className='titre_promo'>
                                                    <div className='d-flex justify-content-between'>
                                                        <div className='d-flex'>
                                                            <i className='fa fa-bookmark'></i>
                                                            <h3>Menu spécial site</h3>
                                                        </div>
                                                        <div className=''>
                                                            <button className='btn btn-sm add_service' onClick={() => handleAddSpecial()}><i className='fa fa-plus'></i></button>
                                                        </div>
                                                    </div>
                                                </div>
                                                {errorSpecial !== "" ? <p className='errorValue'>{errorSpecial}</p> : ''}
                                                {viewSpecial()}
                                            </div>
                                        </div>
                                    </div>
                                    <div className='action mt-3'>
                                        <div className='d-flex justify-content-center'>
                                            {loading ? <Button className='btn btn_ajouteInformation mt-3' disabled>
                                                <Spinner

                                                    animation="border"
                                                    size="sm"
                                                    variant="info"
                                                />
                                                Loading...
                                            </Button> : <button className='btn btn-ajoute_date' onClick={handleEnregistrer}>Enregistrer</button>}

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='parametrageSansOffre'>
                                {loadDataSansOffre === true ?
                                    <div className="d-flex justify-content-center">
                                        <Spinner animation="border" className="load" variant="info" size="md" />
                                    </div> : ''}
                                <div className='row'>
                                    <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                        <div className='bloc_promo'>
                                            <div className='titre_promo  pb-1'>
                                                <div className='d-flex justify-content-between'>
                                                    <div className='d-flex'>
                                                        <i className='fa fa-bookmark'></i>
                                                        <h3>Sans Offre</h3>
                                                    </div>
                                                </div>
                                            </div>
                                            {viewSansOffre()}
                                        </div>
                                    </div>
                                    <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                        <div className='bloc_promo'>
                                            <div className='titre_promo pb-1'>
                                                <div className='d-flex justify-content-between'>
                                                    <div className='d-flex'>
                                                        <i className='fa fa-bookmark'></i>
                                                        <h3>Réservation en direct</h3>
                                                    </div>
                                                </div>
                                            </div>
                                            {viewDirect()}
                                        </div>
                                    </div>
                                </div>
                                <div className='action mt-3'>
                                    <div className='d-flex justify-content-center'>
                                        {loadingSansOffre ? <Button className='btn btn_ajouteInformation mt-3' disabled>
                                            <Spinner

                                                animation="border"
                                                size="sm"
                                                variant="info"
                                            />
                                            Loading...
                                        </Button> : <button className='btn btn-ajoute_date' onClick={handleEnregistrerSansOffre}>Enregistrer</button>}

                                    </div>
                                </div>
                                <p className='version'>Version 1</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default OffrePromo